// @system — Article hero: the 16:9 cover (1600×900) above the body, or the branded placeholder.
// It is the page's LCP element, so it is eager + high fetch priority with explicit dimensions.
import { CoverPlaceholder } from '../BlogPage/CoverPlaceholder'

// `fetchpriority` (lowercase) is the HTML attribute; React 18 forwards unknown lowercase
// attributes untouched, and @types/react 18 does not declare it, hence the spread.
/** @type {Record<string, string>} */
const LCP_IMG_ATTRS = { fetchpriority: 'high' }

/**
 * @typedef {object} ArticleHeroProps
 * @property {import('../BlogPage/helpers').BlogPost} post
 */

/** @param {ArticleHeroProps} props */
export function ArticleHero({ post }) {
  const src = post.coverImage || post.thumbnailImage
  return (
    <div className="mb-8 overflow-hidden rounded-lg border bg-brand-surface">
      {src ? (
        <img
          src={src}
          // The <h1> right above names the article; the hero itself is decorative.
          alt=""
          width={1600}
          height={900}
          decoding="async"
          className="aspect-video w-full object-cover"
          {...LCP_IMG_ATTRS}
        />
      ) : (
        <CoverPlaceholder label={post.category} />
      )}
    </div>
  )
}
